/**
 * Arabic UI strings of the application shell. Page texts stay next to their components
 * (as in the original); this module is the place to add another locale later
 * (e.g. `en.ts` with the same keys and a locale switch in the shell).
 */
export const ar = {
  appName: 'PIROCHI',
  division: 'Chocolate Division',
  brandFull: 'PIROCHI Luxury Chocolate',
  credit: 'إعداد صابر الصابري',
  footer: 'إعداد صابر الصابري · PIROCHI Luxury Chocolate',
  clearAll: 'مسح كل البيانات',
  settings: 'الإعدادات',
  system: 'النظام',
  logout: 'تسجيل الخروج',
  skipToContent: 'تخطي إلى المحتوى',
  login: {
    title: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    submit: 'دخول',
    forgot: 'نسيت كلمة المرور؟',
    forgotHelp: 'تواصل مع مدير النظام لإعادة تعيين كلمة المرور (إرسال البريد غير مُفعّل).',
  },
  notFound: 'الصفحة غير موجودة',
  newVersionTitle: 'تم تحديث النظام',
  newVersionText: 'صدرت نسخة جديدة من التطبيق أثناء فتح هذه الصفحة. أعد تحميل الصفحة لمتابعة العمل.',
  pageErrorTitle: 'تعذر عرض هذه الصفحة',
  pageErrorText: 'حدث خطأ غير متوقع. أعد تحميل الصفحة، وإذا تكرر الخطأ أبلغ مدير النظام.',
  reloadPage: 'إعادة تحميل الصفحة',
  backToDashboard: 'العودة للوحة القيادة',
  forbidden: 'ليست لديك صلاحية لعرض هذه الصفحة',
} as const;

export type Strings = typeof ar;
export const t = ar;
